import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../../../elements/ui/card';
import { Sun, Home } from 'lucide-react';

interface CombinedClimateCardProps {
  // Both arrive already formatted with their unit ("22.5 °C"), so neither gets one appended below.
  temperatureInside: string | null;
  temperatureOutside: string | null;
  humidityInside: number | null;
  humidityOutside: number | null;
}

const CombinedClimateCard: React.FC<CombinedClimateCardProps> = ({
  temperatureInside,
  temperatureOutside,
  humidityInside,
  humidityOutside
}) => {
  return (
    <Card className="h-full">
      <CardHeader className="pb-3">
        <CardTitle>Climate Overview</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-6">
          {/* Temperature Section */}
          <div className="space-y-3">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Temperature</p>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Home className="h-4 w-4 text-indigo-500" />
                <span className="text-sm text-gray-500">Inside</span>
                <span className="ml-auto text-xl font-semibold text-indigo-600">{temperatureInside ?? '—'}</span>
              </div>
              <div className="flex items-center gap-2">
                <Sun className="h-4 w-4 text-green-500" />
                <span className="text-sm text-gray-500">Outside</span>
                <span className="ml-auto text-xl font-semibold text-green-600">{temperatureOutside ?? '—'}</span>
              </div>
            </div>
          </div>

          {/* Humidity Section */}
          <div className="space-y-3">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Humidity</p>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Home className="h-4 w-4 text-blue-500" />
                <span className="text-sm text-gray-500">Inside</span>
                <span className="ml-auto text-xl font-semibold text-blue-600">
                  {humidityInside != null ? `${humidityInside}%` : '—'}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Sun className="h-4 w-4 text-teal-500" />
                <span className="text-sm text-gray-500">Outside</span>
                <span className="ml-auto text-xl font-semibold text-teal-600">
                  {humidityOutside != null ? `${humidityOutside}%` : '—'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CombinedClimateCard;
